import React, { Component } from 'react';
import _ from 'underscore';
import moment from 'moment';
import ga from 'analytics';

import Utils from 'utils/Utils.js';
import DateUtils from 'utils/DateUtils.js';

import SurveyPageDate from './SurveyPageDate.js';


const daysToTimeValue = 86400000;

class SurveyPageDateContainer extends Component {
    constructor(props) {
        super(props);
        this.initialState = {selectedDate:null, valid:false, validDateText:true};
        this.state = this.props.savedState || this.initialState;
        if(!this.props.savedState) {
            this.state = this.applyPersistedState();
        }
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeDateText = this.onChangeDateText.bind(this);
    }
    componentWillMount() {
        ga('send', 'pageview', { 'page': '/virtual/survey-page-date' }); 
    }
    applyPersistedState() {
        var userChallenge = Utils.deref(this.props.surveyPage, 'challenge.userChallenge', null);
        if(userChallenge && _.isFinite(userChallenge.value)) {
            var epochDays = userChallenge.value;
            var time = epochDays*daysToTimeValue;
            var momentDate = moment.utc(time).startOf('day');
            var validDateText = Boolean(momentDate && momentDate.isValid());
            var selectedDate = momentDate;
            var state = {selectedDate:selectedDate, valid:this.isValid(selectedDate), validDateText:validDateText};
            return state;
        }
        return this.state;
    }
    onChange(date) {
        console.log('SurveyPageDateContainer.onChange', date);
        var valid = this.isValid(date);
        this.setState({selectedDate:date,valid:valid, validDateText:true});
    }
    onChangeDateText(event) {
        var dateText = event.target.value;
        var momentDate = Boolean(dateText) ? moment(dateText, DateUtils.formatDisplay, true) : null; 
        var validDateText = Boolean(momentDate && momentDate.isValid());
        this.setState({validDateText:validDateText});
    }
    onSubmit(event) {
        if(this.state.valid) {
            var dateLocal = this.state.selectedDate;
            var utc = moment.utc([dateLocal.year(), dateLocal.month(), dateLocal.date()]);
            //var local = moment([dateLocal.year(), dateLocal.month(), dateLocal.date()]);
            //console.log("Date: " + dateLocal.format(DateUtils.formatDisplay) + " utc.getTime: " + ((utc.toDate().getTime())/daysToTimeValue) + " local.getTime:" + ((local.toDate().getTime())/daysToTimeValue));
            //console.log("Date final: " + Math.floor((utc.toDate().getTime())/daysToTimeValue));
            this.props.onSubmit(event,{challengeId:this.props.surveyPage.challenge.id, value:Math.floor((utc.toDate().getTime())/daysToTimeValue)}, this.state);
        } else {
            event.preventDefault();
        }
    }
    isValid(date) {
        return ((typeof date)==='object' && date.isValid());
    }
    render() {
        const value = this.state.selectedDate ? this.state.selectedDate.format(DateUtils.formatDisplay) : '';
        return <SurveyPageDate
                   surveyPage={this.props.surveyPage}
                   inlineButtons={this.props.inlineButtons}
                   pageNum={this.props.pageNum}
                   numPages={this.props.numPages}
                   onSkip={this.props.onSkip}
                   value={value}
                   onSubmit={this.onSubmit}
                   onChange={this.onChange}
                   onChangeDateText={this.onChangeDateText}
                   valid={this.state.valid && this.state.validDateText}
                   format={DateUtils.formatDisplay}
                   />;
    }

}

export default SurveyPageDateContainer;



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageDateContainer.js